import MomentUtils from '@date-io/moment'
import { makeStyles } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import 'moment/locale/pt-br'
import React, { useContext, useEffect } from 'react'
import { FaPlus, FaTrashAlt } from 'react-icons/fa'
import uuid from 'uuid/v4'
import Context from '../../context'

const initialDateData = () => {
  return {
    uuid: uuid(),
    value: '',
    startDate: new Date(),
    endDate: new Date(),
    status: 2
  }
}

function EventsTypeDiscounts() {
  const { formObject, setFormObject, partnersCodesItens, setPartnersCodesItens } =
    useContext(Context)
  const classes = useStyles()

  // const [file, setFile] = useState();

  useEffect(() => {
    if (partnersCodesItens.length === 0) {
      setPartnersCodesItens([initialDateData()])
    }
    // console.log('partnerCodeItens: ', partnersCodesItens);
  }, [])

  const fileReader = new FileReader()
  function parseCSV(file) {
    // return file.slice(file.indexOf('\n') + 1).split('\n');
    return file.split(/[\r\n]+/g)
  }

  const handleOnChange = e => {
    // setFile(e.target.files[0]);
    const file = e.target.files[0]

    e.preventDefault()

    if (file) {
      fileReader.onload = function (event) {
        const csvOutput = event.target.result
        const parsedCSV = parseCSV(csvOutput)
        setPartnersCodesItens([
          {
            uuid: uuid(),
            value: [parsedCSV],
            startDate: new Date(),
            endDate: new Date(),
            status: 1
          }
        ])
      }

      fileReader.readAsText(file)
    }
  }

  const handleInputEvent = evt => {
    setFormObject({
      ...formObject,
      [evt.target.name]: Number(evt.target.value)
    })
  }

  const handleCodesEvent = (uuid, type) => date => {
    const newArr = partnersCodesItens.map(item => {
      if (item.uuid === uuid) return { ...item, [type]: date }
      if (uuid === 'codeList') return { ...item, [type]: date }
      return { ...item }
    })

    setPartnersCodesItens([...newArr])
  }

  const handleValueChange = (uuid, value) => {
    const newArr = partnersCodesItens.map(item => {
      if (item.uuid === uuid) return { ...item, value }
      return { ...item }
    })

    setPartnersCodesItens([...newArr])
  }

  const handleChangeItem = (type, uuid = null) => {
    if (type === 'add') {
      setPartnersCodesItens(partnerCodesItens => [...partnerCodesItens, initialDateData()])
    }

    if (!!uuid && type === 'remove') {
      const newArr = partnersCodesItens.filter(item => item.uuid !== uuid)
      setPartnersCodesItens([...newArr])
    }
  }
  console.log('discount type', formObject.discountType)

  return (
    <>
      <div style={{ marginTop: '15px' }} className="row">
        <div className="form-group col-4">
          <label htmlFor="discountType">
            Selecione o tipo do desconto (QrCode,Cupom ou lista de cupons)
          </label>
          <select
            name="discountType"
            value={formObject.discountType}
            className="form-control"
            onChange={handleInputEvent}
          >
            <option value={1}>Padrão</option>
            <option value={2}>Lista de cupons</option>
            <option value={3}>Cupom</option>
          </select>
        </div>
      </div>

      {formObject.discountType === 3 &&
        partnersCodesItens?.map(item => (
          <div key={item.uuid} className="card" style={{ padding: '10px', marginBottom: '15px' }}>
            <div key={item.uuid} className="row">
              <div className="form-group col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Código"
                  name="value"
                  id={item.uuid}
                  value={item.value}
                  onChange={e => handleValueChange(item.uuid, e.target.value)}
                />
              </div>
              <div className="d-inline-flex justify-content-around align-content-center">
                <button
                  onClick={() => handleChangeItem('add')}
                  type="button"
                  className="btn clube-button clube-btn clube-blue"
                >
                  <FaPlus />
                </button>
                <button
                  disabled={partnersCodesItens.length === 1}
                  onClick={() => handleChangeItem('remove', item.uuid)}
                  type="button"
                  className="btn clube-button clube-btn bg-danger text-white"
                >
                  <FaTrashAlt />
                </button>
              </div>
            </div>

            <div className="row">
              <div
                className="col-6 d-flex flex-row justify-content-between"
                style={{ padding: 5, marginLeft: '10px' }}
              >
                <div style={{ paddingRight: 2 }}>
                  <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                    <KeyboardDatePicker
                      margin="normal"
                      id={`startDay-${item.uuid}`}
                      label="Data de início"
                      format="DD/MM/YYYY"
                      value={item.startDate}
                      onChange={handleCodesEvent(item.uuid, 'startDate')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div style={{ paddingLeft: 2 }}>
                  <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                    <KeyboardDatePicker
                      margin="normal"
                      id={`endDay-${item.uuid}`}
                      name="endDay"
                      label="Data de final"
                      format="DD/MM/YYYY"
                      minDate={item.startDate}
                      minDateMessage="A Data final não pode ser inferior ao início."
                      value={item.endDate}
                      onChange={handleCodesEvent(item.uuid, 'endDate')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </div>
        ))}

      {formObject.discountType === 2 && (
        <div className="card" style={{ padding: '10px', marginBottom: '15px' }}>
          <div className={classes.inputGroup}>
            <span>Selecione o arquivo csv contendo a lista de cupons</span>
          </div>

          <div className="row">
            <input
              type="file"
              accept=".csv"
              className="btn clube-button clube-btn clube-blue"
              onChange={handleOnChange}
            />
            {/* <div className="d-inline-flex justify-content-around align-content-center">
              <button
                // onClick={e => handleOnSubmit(e)}
                type="button"
                className="btn clube-button clube-btn clube-blue"
              >
                <FaPlus />
              </button>
            </div> */}
          </div>
          <div className="row">
            <div
              className="col-6 d-flex flex-row justify-content-between"
              style={{ padding: 5, marginLeft: '10px' }}
            >
              <div style={{ paddingRight: 2 }}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                  <KeyboardDatePicker
                    margin="normal"
                    id={`startDay-${uuid()}`}
                    label="Data de início"
                    format="DD/MM/YYYY"
                    value={partnersCodesItens[0]?.startDate}
                    onChange={handleCodesEvent('codeList', 'startDate')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div style={{ paddingLeft: 2 }}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                  <KeyboardDatePicker
                    margin="normal"
                    id={`endDay-${uuid()}`}
                    name="endDay"
                    label="Data de final"
                    format="DD/MM/YYYY"
                    minDate={partnersCodesItens[0]?.startDate}
                    minDateMessage="A Data final não pode ser inferior ao início."
                    value={partnersCodesItens[0]?.endDate}
                    onChange={handleCodesEvent('codeList', 'endDate')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const useStyles = makeStyles({
  csvContainer: {
    maxWidth: '50em',
    flexWrap: 'wrap'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea, & select': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important',
      '&[disabled]': {
        opacity: 1,
        background: '#0000000a'
      }
    },
    '& input, & textarea, & select': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input, & > div select': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div, & select': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },

  plainButton2: {
    display: 'block',
    margin: '2px',
    padding: '6px 5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },

  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },

  spacer: {
    flexGrow: 1
  }
})

export default EventsTypeDiscounts
